export const BASE_URL = 'https://mintish-nft.com/';
export const POST_REQUEST = "POST";
export const CONTENT_TYPE = "application/json";
export const PUBLIC_JWT_TOKEN = "Logicease123";
export const GET_REQUEST = "GET";
export const PUT = "PATCH";


//http://mintish-nft.com/